import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicLaptop({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M14.5 12.5c.28 0 .5.22.5.5v.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V13c0-.28.22-.5.5-.5zm-2-10.25c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75h-9c-.97 0-1.75-.78-1.75-1.75V4c0-.97.78-1.75 1.75-1.75h9zm0 1.5h-9a.25.25 0 00-.25.25v6c0 .14.11.25.25.25h9c.14 0 .25-.11.25-.25V4a.25.25 0 00-.25-.25z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicLaptop.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicLaptop.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicLaptop svgRef={ref} {...props} />);
export default ForwardRef;
